/* eslint-disable */
import firebase from 'firebase'

firebase.initializeApp({
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID
})

const db = firebase.database()

const storeChatGroup = (chatGroupId, chatGroup) => db.ref(`chat_groups/${chatGroupId}/`).set(chatGroup)
const getChatGroup = chatGroupId => firebase.database().ref(`chat_groups/${chatGroupId}`).once('value')
const storeEmployeeChatGroup = (chatGroupId, employeeCode, employeeChatGroup) => db.ref(`chat_groups/${chatGroupId}/employees/${employeeCode}`).set(employeeChatGroup)
const getInstitution = institutionCode => db.ref(`institutions/${institutionCode}`).once('value')
const storeInstitution = (institutionCode, institution) => db.ref(`institutions/${institutionCode}/`).set(institution)

const storeMessage = (chatGroupId, messageId, message) => db.ref(`messages/${chatGroupId}/${messageId}`).set(message)
const updateMessage = (chatGroupId, messageId, message) => db.ref(`messages/${chatGroupId}/${messageId}`).update(message)
const deleteMessage = (chatGroupId, messageId) => db.ref(`messages/${chatGroupId}/${messageId}`).remove()

const updateMessageChatGroup = (chatGroupId, total_messages_chat_group) => firebase.database().ref(`chat_groups/${chatGroupId}/total`).transaction(function (currentTotal) {
  // If node/clicks has never been set, currentRank will be `null`.
  if (currentTotal) return currentTotal + 1
  else return total_messages_chat_group
})

const updateMessageInstitutions = (institutionCode, total_messages_chat_group, company_code) => firebase.database().ref(`institutions/${institutionCode}/total_messages/${company_code}`).transaction(function (currentTotal) {
  // If node/clicks has never been set, currentRank will be `null`.
  if (currentTotal) {
    if (total_messages_chat_group < currentTotal) {
      return currentTotal + 1
    }
    return total_messages_chat_group
  } else {
    return total_messages_chat_group
  }
})

export {db}

export default {
  storeChatGroup,
  getChatGroup,
  storeMessage,
  updateMessage,
  deleteMessage,
  storeEmployeeChatGroup,
  updateMessageChatGroup,
  updateMessageInstitutions,
  getInstitution,
  storeInstitution
}



// WEBPACK FOOTER //
// ./src/firebase/index.js